import React from "react";
import PropTypes from "prop-types";
import SecondBlue from "../icons/second-blue.png";
import Second from "../icons/second.png";

const ContactDetailStepIcon = ({ show, completed }) => {
  let iconSrc;

  if (completed || show) {
    iconSrc = Second;
  } else {
    iconSrc = SecondBlue;
  }

  return (
    <div className="WH32">
      <img src={iconSrc} alt="Step Icon" />
    </div>
  );
};



ContactDetailStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default ContactDetailStepIcon;
